export const COMMUNITY_INVITE_SESSION_KEY = "community-invite-join-session";
